import './components/ofi.min';

/* eslint-disable no-unused-vars */
var utils_vars = {
	root: document.documentElement,
	head: document.head,
	body: document.body,
	header: document.getElementById('main-header'),
	nav: document.getElementById('main-nav'),
	footer: document.getElementById('main-footer'),
	headerDown: false,
	originalState: true,
	breakpoint: {
		xs: 0,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
		xxl: 1400,
	},
	observerReady : "IntersectionObserver" in window,
    observerLoaded : false,
    observerStartLoaded : false,
	objectFitReady: "objectFit" in document.documentElement.style,
	lazyImageObserver: false,
	srcsetReady: 'sizes' in document.createElement('img'),
	notStarted: true,
	webmReady: false,
	menuOpen: false,
	closeMenu: false,
	isMobile: false,
	overlay: document.getElementById('overlay'),
	sliderLoaded: false,
	
	// funzione di caricamento ajax
	ajaxLoad(url, method, contentType, type, params, callback) {
		var oReq = new XMLHttpRequest();
		oReq.onload = function (e) {
			var response = e.target.response;
			if (callback) {
				callback(response);
			}
		};
		oReq.open(method, url, true);
		if (type) {
			oReq.responseType = type;
		}
		if (contentType) {
			oReq.setRequestHeader('Content-type', contentType);
		}
		if (params) {
			oReq.send(params);
		} else {
			oReq.send();
		}
	},

	// DOM ready
	domReady: (callback) => {
		document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
	},

	// loop helper
	forEach(array, callback, scope) {
		for (var i = 0; i < array.length; i++) {
			callback.call(scope, i, array[i]);
		}
	},

	isImageLoaded(img, callback) {
		img.onload = () => callback();
	},

	checkObjectFit() {
		if (!utils_vars.objectFitReady) {
			// loadScript(utils_vars.baseUrl + '/js/build/ofi.min.js', false, null);
		}
	},

	injectsmxConsole() {
		if (utils_vars.docWidth > utils_vars.breakpoint.medium) {
			// console.log('%c\n\n\nJust one more website by %csmx+LAB %c- https://www.smxlab.com %c👌🏻 %c\n\nFollow us on: \n\nhttps://www.facebook.com/smxlab%c\n\nhttps://www.linkedin.com/company/smx-lab %c\n\ninfo@smxlab.com %c\n\nGet in touch! %c👋🏻\n\n\n', 'color:#595959;font-size:12px;', 'font-weight: bold;font-size: 12px;', 'color:#999;', 'font-size:20px;', 'color:#595959;', '', '', 'color:#595959;font-size: 12px;', 'font-size:20px;');
		}
	},

	////// detect support for Intersection Observer and load a fallback script if not supported ////////
	loadIntersectionScript(callback) {
		if (!this.observerReady) {
			if (!this.observerStartLoaded) {
				var intersectionScript = document.createElement("script");
				intersectionScript.id = 'observer-fallback';
				intersectionScript.src = './components/intersection-observer.js';
				this.body.appendChild(intersectionScript);
				this.observerStartLoaded = true;
				intersectionScript.addEventListener('load', function () {
					this.observerLoaded = true;
					callback();
				});
			} else {
				if (!this.observerLoaded) {
					var appendedScript = document.getElementById('observer-fallback');
					appendedScript.addEventListener('load', function () {
						callback();
					});
				} else {
					callback();
				}
			}
		} else {
			callback();
		}
	},

	loadScript(link, async, callback) {
		var script = document.createElement("script");
		script.src = link;
		if (async) {
			script.setAttribute('async', '');
		}
		if (callback) {
			script.addEventListener('load', callback);
		}
		document.body.appendChild(script);
	},

}

export default utils_vars
